import React, { useRef, useState, useEffect } from 'react';
import { useWindowSize } from 'react-use';

const SlideToggle = ({ slideController, slideTarget, slideDown, slideAllDown, slideAllUp, mobileOnlyBreakPoint, initialToggleState }) => {
	const { width, height } = useWindowSize();
	const [toggleState, setToggleState] = useState(initialToggleState || 'slideDown');
	const [initialHeight, setInitialHeight] = useState(0);
	const [targetHeight, setTargetHeight] = useState(0);

	const toggle = () => {
		if (toggleState === 'slideUp') {
			setToggleState('slideDown');
			setTargetHeight(initialHeight);
		}

		if (toggleState === 'slideDown') {
			setToggleState('slideUp');
			setTargetHeight(100);
		}
	};

	const target = useRef(null);

	useEffect(() => {
		const height = target.current.getBoundingClientRect().height;

		if (mobileOnlyBreakPoint && width > mobileOnlyBreakPoint) {
			setToggleState('slideDown');
			setInitialHeight(0);
		} else {
			setInitialHeight(height);
			setToggleState('slideUp');
			setTargetHeight(0);
		}
	}, [width, height, mobileOnlyBreakPoint]);

	useEffect(() => {
		if (slideDown) {
			setToggleState('slideDown');
			setTargetHeight(initialHeight);
		}
	}, [slideDown, initialHeight]);

	useEffect(() => {
		if (slideAllDown) {
			setToggleState('slideDown');
			setTargetHeight(initialHeight);
		}
	}, [slideAllDown, initialHeight]);

	useEffect(() => {
		if (slideAllUp) {
			setToggleState('slideUp');
			setTargetHeight(0);
		}
	}, [slideAllUp, initialHeight]);

	// const SlideController = slideController;
	// console.log(slideController);
	// const SlideController = React.cloneElement(slideController, { toggle });

	return (
		<div className='slide-toggle'>
			<div className={`slide-controller ${toggleState}`} onClick={toggle}>
				{/* {React.cloneElement(slideController, { toggle })} */}
				{slideController}
			</div>

			<div
				ref={target}
				className={`slide-target ${toggleState}`}
				style={{
					height: initialHeight ? `${targetHeight}px` : 'auto',
					overflow: 'hidden',
					transition: 'all 200ms cubic-bezier(0.68, 0, 0.265, 1)',
				}}>
				{slideTarget}
			</div>
		</div>
	);
};

export default SlideToggle;
